import { render } from "./GtrPoints.vue?vue&type=template&id=7141fd2c&ts=true"
import script from "./GtrPoints.vue?vue&type=script&lang=ts"
export * from "./GtrPoints.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__